import { korrigiereJev } from "../../shared/jev-schreibweise.js";
import { kontoKennung } from "./konto-lage.js";

/**
 * Gibt es Jev (TypeSafe AI) für dieses Konto? (29.09.2026, Ticket 2778)
 *
 * Jev liest die Mitschrift mit — der Server fragt ihn nur für Konto 1
 * (server/jev-schatten.ts, `jevSchattenAn`; server/stille-auto-routen.ts). Was
 * an Jev hängt, zeigt die Oberfläche darum nur diesem Konto: ein Schalter für
 * andere bewirkte nichts. Diese Frage hat EINEN Besitzer — wer sie braucht,
 * ruft diese Funktion und schreibt die Konto-Nummer nicht noch einmal hin.
 *
 * ⚠️ Kein Sicherheitstor: `__voiceV8Uid` setzt die App nach der Anmeldung, es
 *    entscheidet nur, was angezeigt wird. Ob Jev gefragt wird, entscheidet
 *    allein der Server.
 * ⚠️ Vor der Anmeldung gilt die zuletzt angemeldete Kennung (konto-lage.ts,
 *    `kontoKennung`) — sonst sähe Martin beim Start kurz ein Konto ohne Jev.
 */
export function jevMoeglich(): boolean {
  return kontoKennung() === 1;
}

/**
 * Solange das Konto GANZ unbekannt ist (kein Login, keine gemerkte Kennung), darf nichts „jev“ überschreiben:
 * die Oberfläche zeigt dann „Nach Frage“, aber der Wert gehört vielleicht Konto 1. Wahr = der Tipp bleibt ohne Wirkung.
 */
export function jevStufeGeschuetzt(gespeichert: unknown): boolean {
  return gespeichert === "jev" && kontoKennung() === null;
}

/**
 * „Jef“/„Jeff“ → „Jev“ in einem Text — nur für Martins Konto. (30.09.2026,
 * Tickets 2842/2854)
 *
 * Die Erkennung hört „Jev“ als „Jef“. Der Server schreibt es nach der
 * Erkennung richtig (server/eigene-begriffe.ts, voice-command.ts); das hier
 * gilt dem, was schon WÄHREND des Sprechens in der Karte steht — sonst
 * stünde dort „Jef“, bis der Server antwortet, und der Text vom Gerät ginge
 * falsch los. Die Regel selbst: shared/jev-schreibweise.ts.
 */
export function mitJevSchreibweise(text: string): string {
  return jevMoeglich() ? korrigiereJev(text) : text;
}
